import {getToken, getCusToken} from './../../../../services/services-jwt'

export default {
	token: getToken() || null,
	cusToken: getCusToken() || null,
	user: {}
}
